module.exports = __webpack_public_path__ + "img/time.18a6d0f1.svg";